import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ element: Component, role }) => {
    const user = JSON.parse(localStorage.getItem('user'));

    if (!user) {

        return <Navigate to="/login" />;
    }


    const allowedRoles = Array.isArray(role) ? role : [role];

    if (!allowedRoles.includes(user.role)) {

        return <Navigate to="/unauthorized" />;
    }


    return <Component />;
};

export default PrivateRoute;
